const SET_SELECTED_EXTRA_SERVICES = 'SET_SELECTED_EXTRA_SERVICES';
const UNSET_SELECTED_EXTRA_SERVICES = 'UNSET_SELECTED_EXTRA_SERVICES';

export const action_setSelectedExtraServices = payload => ({
  type: SET_SELECTED_EXTRA_SERVICES,
  payload,
});
export const action_unsetSelectedExtraServices = () => ({
  type: UNSET_SELECTED_EXTRA_SERVICES,
});

export const reducer_selectedExtraServices = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case SET_SELECTED_EXTRA_SERVICES:
      return payload;
    case UNSET_SELECTED_EXTRA_SERVICES:
      return [];
    default:
      return state;
  }
};

export const selector_selectedExtraServices = ({ extraServices }) =>
  extraServices.selectedExtraServices;
